import { userAgentParser } from '@common/UserAgentParser/UserAgentParser'

import type { TOsVersion } from '../definitions'

/**
 * Os verziószámának elkérése.
 * @param ua - UserAgent.
 */
export default function getOsVersion (ua: string): TOsVersion {
  return userAgentParser.getOsVersion(ua)
}
